export enum mockVariablesForValues {
  AUSTRIA_OR_GERMANY_GOOD = 'ausO',
  SURELY_NOT_US = 'surelyNotUS',
  OTHER_RAX_REGION = 'otherTaxRegion',
}

export const mockReasonsForTinMissing: { label: string; value: string }[] = [
  { label: 'Reason 1', value: 'reason1' },
  { label: 'Reason 2', value: 'reason2' },
  { label: 'Reason 3', value: 'reason3' },
];
